import React, { useState } from "react";
import NextImage from "next/image";

import { FlexDiv } from "@/components/Atoms/Box";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Button from "@/components/Atoms/Button";
import Modal from "@/components/Molecules/Modal";

import Typography from "@/foundation/Typography/V1";

import {
  Accordion,
  AccordionText,
  AccordionWrap,
  Arrow,
  ArrowIcon,
  ButtonWrap,
  CloseBtn,
  DownloadSection,
  DropdownWrap,
  ImageDownload,
  MenuLink,
} from "../style";
import { ShyftPassPageMenu } from "@/constants/HeaderMenu";
import { useAppSelector } from "@/hooks";

const bg_image =
  "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-card-mobile-drawer.png";

export const MobileHeader = (props: any) => {
  const { onClose } = props || {};
  return (
    <FlexDiv
      position={"relative"}
      alignItems="center"
      justifyContent={"space-between"}
      px="20px"
      pt="24px"
      pb="24px"
    >
      <Typography variant="routelink1" to="/">
        <div className="shyft-pass-drawer-logo-container">
          <NextImage
            className="brand-logo-web"
            alt=""
            src="https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-logo-footer.png"
            fill={true}
          />
        </div>
      </Typography>

      <div className="drawer-close-button" onClick={onClose}>
        <SVGSprite icon={"icon-close"} width={"20.95px"} height={"20.95px"} />
      </div>
    </FlexDiv>
  );
};
function ShyftMobileDrawer(props) {
  const { onClose = () => {}, token, Logout = () => {} } = props || {};
  const [dorpDown, setDropdown] = useState("");

  const { data } = useAppSelector((state) => state.healthProgramV1);

  const ctaTitle =
    data?.hero?.hero_cta_title_secondary ||
    "Get your Shyft Pass till 12th May at 30% off!";

  return (
    <Modal
      height={"100%"}
      overlayClosable
      onClose={onClose}
      width={"100%"}
      bodyPadding={"0px"}
      mobilewidth={"100%"}
    >
      <FlexDiv
        className="shyft-pass-drawer"
        flexDirection={"column"}
        height="100%"
      >
        <MobileHeader onClose={onClose} />
        <FlexDiv flexDirection={"column"} mt="20px" style={{ gap: "20px" }}>
          {ShyftPassPageMenu?.map((menu, index) => {
            return (
              <AccordionWrap
                key={index}
                flexDirection={"column"}
                style={{ marginBottom: "0px", zIndex: 1 }}
              >
                <Accordion
                  style={{ paddingLeft: "30px", paddingRight: "0px" }}
                  alignItems={"center"}
                  onClick={
                    menu.id !== dorpDown
                      ? () => setDropdown(menu.id)
                      : () => setDropdown("")
                  }
                >
                  <AccordionText
                    className={`menu-link-text ${
                      index === 0 && "menu-link-text-first-item"
                    }`}
                    opacity={dorpDown === menu.id ? 1 : 0.4}
                    variant={menu.type || "routelink1"}
                    // to={menu.link}
                    // href={menu.link}
                    fontSize={"32px"}
                    fontFamily={"var(--dm-sans)"}
                    link1Color="#ffffff"
                    style={{ lineHeight: "36.7px" }}
                    onClick={() => {
                      document?.getElementById(menu.link)?.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                      });
                      onClose();
                    }}
                  >
                    {menu.title}
                  </AccordionText>
                </Accordion>
              </AccordionWrap>
            );
          })}
        </FlexDiv>
        <div className="shyft-page-mobile-drawer-pass-card">
          <div>
            <div className="card-section">
              <NextImage
                className="bg-image"
                alt="shyft-pass-card"
                src={bg_image}
                fill={true}
              />
            </div>
          </div>
        </div>

        <div className="cta-section">
          <Button
            variant={"primary1"}
            onClick={() => {
              document
                ?.getElementById("shyft-pass-register-section")
                ?.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                });
              onClose();
            }}
          >
            {ctaTitle}
          </Button>
        </div>
      </FlexDiv>
    </Modal>
  );
}

export default ShyftMobileDrawer;
